import script from "./ToastProvider.vue?vue&type=script&lang=ts&setup=true"
export * from "./ToastProvider.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__